import { Component } from '@angular/core';
import { LanguageService } from '../services/language.service';
import CONFIGURATION, { hasLandingPageFor, landingPagePathFor } from '../../configurations/configuration';
import { ENVIRONMENT } from 'environments/environment';
import { ModalService } from 'app/services/modal.service';

declare var window: any;

@Component({
  selector: 'footer-section',
  templateUrl: './footer.html'
})
export class FooterComponent {
  appLink: any;
  countryCode: string;
  mediaPressLink: string;
  learningCenterLink: string;
  mediaSocialLink: any;
  referralProgram: any;
  showPrivacyNoticeInvoiceFinancing: boolean;
  showPrivacyNoticeMalay: boolean;
  languages; Array;
  headerLogoClassNamePrefix: any;
  ENVIRONMENT: any;
  CONFIGURATION: any;
  hasLandingPageFor: any;
  landingPagePathFor: any;
  showDisclosureNotice: boolean;
  disclosureNoticeLink: string;
  faqLink: string;
  websitePrivacyNoticeBmPdf: string;
  websitePrivacyNoticePdf: string;
  websiteTermsAndConditionPdf: string;
  showInvestorAppDownloadLinks: boolean;
  imageBaseUrl: string;
  footerMenuConfiguration: any;

  public constructor(
    private _languageService: LanguageService,
    private _modalService: ModalService
  ) {
    this.appLink = {
      investorAppStore: CONFIGURATION.mobileAppUrl.investor.appStore,
      investorGooglePlay: CONFIGURATION.mobileAppUrl.investor.googlePlay,
    };
    this.ENVIRONMENT = ENVIRONMENT;
    this.hasLandingPageFor = hasLandingPageFor;
    this.landingPagePathFor = landingPagePathFor;
    this.mediaPressLink = CONFIGURATION.mediapress;
    this.mediaSocialLink = {
      facebook: CONFIGURATION.facebook,
      twitter: CONFIGURATION.twitter,
      linkedin: CONFIGURATION.linkedin,
      instagram: CONFIGURATION.instagram,
      line: CONFIGURATION.line
    };
    this.CONFIGURATION = CONFIGURATION;
    this.countryCode = CONFIGURATION.country_code;
    this.learningCenterLink = CONFIGURATION.learningCenter;
    this.referralProgram = CONFIGURATION.referProgram;
    this.showPrivacyNoticeInvoiceFinancing = CONFIGURATION.showPrivacyNoticeInvoiceFinancing;
    this.showPrivacyNoticeMalay = CONFIGURATION.showPrivacyNoticeMalay;
    this.websitePrivacyNoticeBmPdf = CONFIGURATION.websitePrivacyNoticeBmPdf;
    this.websitePrivacyNoticePdf = CONFIGURATION.websitePrivacyNoticePdf;
    this.websiteTermsAndConditionPdf = CONFIGURATION.websiteTermsAndConditionPdf;
    this.languages = this._languageService.getSupportLanguages(CONFIGURATION.supportedLanguages);
    this.headerLogoClassNamePrefix = CONFIGURATION.header_logo_classname_prefix;
    this.showDisclosureNotice = CONFIGURATION.showDisclosureNotice;
    this.disclosureNoticeLink = CONFIGURATION.disclosureNoticeLink;
    this.showInvestorAppDownloadLinks = CONFIGURATION.footer.appDownloadButton.show;
    this.imageBaseUrl = CONFIGURATION.image_base_url;
    this.footerMenuConfiguration = CONFIGURATION.footer.menu;
  }

  ngOnInit() {
    this.getFaqLink(this._languageService.getDefaultLanguage());
  }

  changeLanguage(languageCode: string): void {
    window.location = window.location.origin + '/?lang=' + languageCode;
  }

  getDefaultLanguageLabel(): string {
    return this._languageService.getDefaultLanguageLabel(this._languageService.getDefaultLanguage());
  }

  goToLearningCenter() {
    window.open(this.learningCenterLink, '_blank');
  }

  goToDisclosureNotice() {
    window.open(this.disclosureNoticeLink, '_blank');
  }

  openModal(id: string): void {
    this._modalService.open(id);
  }

  closeModal(id: string): void {
    this._modalService.close(id);
  }

  getFaqLink(currentLanguage: string) {
    this.faqLink = `${CONFIGURATION.help.general[currentLanguage]}?utm_source=mainsite${this.countryCode.toLowerCase()}&utm_medium=footer`;
  }
}
